export default __webpack_public_path__ + "static/media/despre-dimi-home.a3920c0b.png";